import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

export type TextButtonProps = {
	onClick: () => void;
	children: string | JSX.Element;
	icon?: IconProp;
	white: boolean;
	iconRight?: boolean;
	ariaLabel?: string;
	id?: string;
	overrideTextClasses?: boolean;
};

export function TextButton({
	onClick,
	children,
	icon,
	white,
	iconRight,
	ariaLabel,
	id,
	overrideTextClasses,
}: TextButtonProps) {
	return (
		<button
			type='button'
			id={id}
			onClick={onClick}
			className={classnames('flex items-center py-1', {
				'text-white': white,
				'text-black': !white,
				'font-semibold text-sm lg:text-base': !overrideTextClasses,
			})}
			aria-label={typeof children === 'string' ? children : ariaLabel}
		>
			{icon && !iconRight && (
				<FontAwesomeIcon icon={icon} fixedWidth className='mr-1' />
			)}
			{children}
			{icon && iconRight && (
				<FontAwesomeIcon icon={icon} fixedWidth className='ml-1' />
			)}
		</button>
	);
}
